export class CompanyPipelineResult implements ICompanyPipelineResult {
  updateId?: string | undefined;
  personId?: string | undefined;
  changeType?: string | undefined;
  dateCreated?: Date | undefined;
  dateUpdated?: Date | undefined;
  source?: string | undefined;
  companyDetails?: any | undefined;
  contactDetail?: any | undefined;
  executiveSponsorDetail?: any | undefined;
  isIgnored?: boolean | undefined;
  isApplied?: boolean | undefined;
  dateResolved?: Date | undefined;
  resolvedByUserId?: string | undefined;

  constructor(data?: ICompanyPipelineResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      console.log('DATA!', Data);
      this.updateId = Data["updateId"];
      this.personId = Data["personId"];
      this.changeType = Data["changeType"];
      this.dateCreated = Data["dateCreated"] ? new Date(Data["dateCreated"].toString()) : <any>undefined;
      this.dateUpdated = Data["dateUpdated"] ? new Date(Data["dateUpdated"].toString()) : <any>undefined;
      this.source = Data["source"];
      this.companyDetails = Data["companyDetails"];
      this.contactDetail = Data["contactDetail"];
      this.executiveSponsorDetail = Data["executiveSponsorDetail"];
      this.isIgnored = Data["isIgnored"];
      this.isApplied = Data["isApplied"];
      this.dateResolved = Data["dateResolved"] ? new Date(Data["dateResolved"].toString()) : <any>undefined;
      this.resolvedByUserId = Data["resolvedByUserId"];
    }
  }

  static fromJS(data: any): CompanyPipelineResult {
    data = typeof data === 'object' ? data : {};
    let result = new CompanyPipelineResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["updateId"] = this.updateId;
    data["personId"] = this.personId;
    data["changeType"] = this.changeType;
    data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
    data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : <any>undefined;
    data["source"] = this.source;
    data["companyDetails"] = this.companyDetails;
    data["executiveSponsorDetail"] = this.executiveSponsorDetail;
    data["contactDetail"] = this.contactDetail;
    data["isIgnored"] = this.isIgnored;
    data["isApplied"] = this.isApplied;
    data["dateResolved"] = this.dateResolved ? this.dateResolved.toISOString() : <any>undefined;
    data["resolvedByUserId"] = this.resolvedByUserId;
    return data;
  }
}

export interface ICompanyPipelineResult {
  updateId?: string | undefined;
  personId?: string | undefined;
  changeType?: string | undefined;
  dateCreated?: Date | undefined;
  dateUpdated?: Date | undefined;
  source?: string | undefined;
  companyDetails?: any | undefined;
  contactDetail?: any | undefined;
  executiveSponsorDetail?: any | undefined;
  isIgnored?: boolean | undefined;
  isApplied?: boolean | undefined;
  dateResolved?: Date | undefined;
  resolvedByUserId?: string | undefined;
}